import en from './en';
import de from './generated/de';
import { createTranslator, type FlattenDict } from 'schummar-translate/react';

export type Dict = FlattenDict<typeof en>;
export type ValidationKey = keyof FlattenDict<(typeof en)['validations']>;

export const { getTranslator, useTranslator, t, TranslationContextProvider, useGetTranslator } =
    createTranslator({
        sourceLocale: 'en',
        sourceDictionary: en,
        dicts: {
            de,
        },
        fallbackLocale: ['en'],
        dateTimeFormatOptions: { dateStyle: 'medium', timeStyle: 'medium' },
        warn: console.warn,
    });

export const fMoney = <
    T extends { numberFormat(...args: Parameters<typeof t.numberFormat>): any } = typeof t,
>(
    amount: number,
    _t: T = t as unknown as T,
): ReturnType<T['numberFormat']> =>
    _t.numberFormat(amount / 100, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
    });

export const availableLanguages = [
    { code: 'de', flag: 'DE' },
    { code: 'en', flag: 'UK' },
];
